import { render, staticRenderFns } from "./draggable_compat.vue.js?vue&type=template&id=371da4cf!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./draggable_compat.vue?vue&type=template&id=371da4cf"
import script from "./draggable_compat.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./draggable_compat.vue?vue&type=script&lang=js"
export * from "./draggable_compat.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./draggable_compat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports